var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/profile-dropdown.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import throttle from 'lodash/throttle';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchOwnAccounts, logOut, switchAccount } from 'soapbox/actions/auth';
import Account from 'soapbox/components/account';
import { Menu, MenuButton, MenuDivider, MenuItem, MenuLink, MenuList } from 'soapbox/components/ui';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
import { makeGetAccount } from 'soapbox/selectors';
import ThemeToggle from './theme-toggle';
const messages = defineMessages({
  add: {
    "id": "profile_dropdown.add_account",
    "defaultMessage": "Add an existing account"
  },
  theme: {
    "id": "profile_dropdown.theme",
    "defaultMessage": "Theme"
  },
  logout: {
    "id": "profile_dropdown.logout",
    "defaultMessage": "Log out @{acct}"
  }
});
const getAccount = makeGetAccount();

const ProfileDropdown = _ref => {
  let {
    account,
    children
  } = _ref;
  const dispatch = useDispatch();
  const features = useFeatures();
  const intl = useIntl();
  const authUsers = useAppSelector(state => state.auth.get('users'));
  const otherAccounts = useAppSelector(state => authUsers.map(authUser => getAccount(state, authUser.get('id'))));

  const handleLogOut = () => {
    dispatch(logOut());
  };

  const handleSwitchAccount = account => {
    return () => {
      dispatch(switchAccount(account.id));
    };
  };

  const fetchOwnAccountThrottled = throttle(() => {
    dispatch(fetchOwnAccounts());
  }, 2000);

  const renderAccount = account => {
    return /*#__PURE__*/React.createElement(Account, {
      account: account,
      showProfileHoverCard: false,
      withLinkToProfile: false,
      hideActions: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 7
      }
    });
  };

  const menu = React.useMemo(() => {
    const menu = [];
    menu.push({
      text: renderAccount(account),
      to: "/@".concat(account.acct)
    });
    otherAccounts.forEach(otherAccount => {
      if (otherAccount && otherAccount.id !== account.id) {
        menu.push({
          text: renderAccount(otherAccount),
          action: handleSwitchAccount(otherAccount)
        });
      }
    });
    menu.push({
      text: null
    });
    menu.push({
      text: intl.formatMessage(messages.theme),
      toggle: /*#__PURE__*/React.createElement(ThemeToggle, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 67
        }
      })
    });
    menu.push({
      text: null
    });
    menu.push({
      text: intl.formatMessage(messages.add),
      to: '/login/add',
      icon: require('@tabler/icons/plus.svg')
    });
    menu.push({
      text: intl.formatMessage(messages.logout, {
        acct: account.acct
      }),
      to: '/logout',
      action: handleLogOut,
      icon: require('@tabler/icons/logout.svg')
    });
    return menu;
  }, [account, authUsers, features]);
  React.useEffect(() => {
    fetchOwnAccountThrottled();
  }, [account, authUsers]);
  return /*#__PURE__*/React.createElement(Menu, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(MenuButton, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(MenuList, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 7
    }
  }, menu.map((menuItem, idx) => {
    if (menuItem.toggle) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "flex flex-row items-center justify-between px-4 py-1 text-sm text-gray-700 dark:text-gray-400",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 17
        }
      }, menuItem.text), menuItem.toggle);
    } else if (!menuItem.text) {
      return /*#__PURE__*/React.createElement(MenuDivider, {
        key: idx,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120,
          columnNumber: 20
        }
      });
    } else {
      const Comp = menuItem.action ? MenuItem : MenuLink;
      const itemProps = menuItem.action ? {
        onSelect: menuItem.action
      } : {
        to: menuItem.to,
        as: Link
      };
      return /*#__PURE__*/React.createElement(Comp, _extends({
        key: idx
      }, itemProps, {
        className: "truncate",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 15
        }
      }), menuItem.text);
    }
  })));
};

export default ProfileDropdown;